// extracted by mini-css-extract-plugin
export var isShyHeaderMode = "BypUG";
export var overlayLeftPane = "_ybNL";
export var overlayLeftPaneMain = "QAQPf";
export var overlayLeftPaneScrollableContent = "XWj4y";
export var overlayLeftPaneWithAppNames = "XouY9";